<template>
  <VtPage>
    <VtContainer>
      <div class="flex justify-between items-center px-4 py-2.5 gap-4">
        <NuxtLink
          :to="{ name: 'index' }"
          class="flex flex-col"
          :aria-label="t('brand.name')"
        >
          <img src="/brand-dark.svg" :alt="t('brand.name')" class="w-36 h-5" />
          <span
            class="text-xs text-neutral-600 dark:text-neutral-400 leading-snug"
            translate="no"
          >
            {{ t('brand.appName') }}
          </span>
        </NuxtLink>
      </div>
    </VtContainer>
    <NuxtPage />
  </VtPage>
</template>

<script setup lang="ts">
import { NuxtLink, NuxtPage } from '#components'
import { useI18n } from '#i18n'

import { VtContainer, VtPage } from '@/components/vue-ui'
import { useColorMode } from '@/composables/useColorMode'

const { t } = useI18n()

useColorMode()
</script>
